export default "__VITE_ASSET__fWrfc0F4__"